// src/auth/useRole.js
import { useMemo } from "react";
import { useAuth } from "./AuthContext";

const CREATOR_LIKE_ROLES = new Set(["creator", "individual"]);

export default function useRole() {
  const { role: ctxRole, roles, isAdmin: ctxIsAdmin, isCreator: ctxIsCreator } = useAuth() || {};

  const role = useMemo(() => {
    if (ctxRole) return ctxRole;
    if (Array.isArray(roles) && roles.length) {
      return roles.includes("admin") ? "admin" : roles[0];
    }
    return "creator";
  }, [ctxRole, roles]);

  const flags = useMemo(
    () => ({
      role,
      isAdmin: Boolean(ctxIsAdmin || role === "admin"),
      isCreator: Boolean(ctxIsCreator || CREATOR_LIKE_ROLES.has(role)),
    }),
    [ctxIsAdmin, ctxIsCreator, role]
  );

  return flags;
}
